import useAuthenticatedUser from '../useAuthenticatedUser';

const useIsOwner = (ownerId?: string) => {
  const user = useAuthenticatedUser();
  const isOwner = !!user && user.id === ownerId;
  return isOwner;
};

export default useIsOwner;
